<template>
  <section class="organism-value-proposition vision-section">
    <h1 class="main-title">
      Operate smoother. Communicate smarter. Deliver better.
    </h1>
    <p class="vision-description">
      Everything you need to run professional drone operations with clarity and
      confidence.
    </p>
    <div class="vision-cards">
      <FeatureCard
        v-for="(item, index) in items"
        :key="index"
        :icon="item.icon"
        :title="item.title"
        :description="item.description"
      />
    </div>
  </section>
</template>

<script>
import FeatureCard from "@/components/molecules/FeatureCard.vue";

export default {
  name: "ValueProposition",
  components: {
    FeatureCard,
  },
  props: {
    items: {
      type: Array,
      required: true,
      validator: (value) =>
        value.every(
          (item) => typeof item === "object" && item.title && item.description
        ),
    },
  },
};
</script>

<style scoped>
.organism-value-proposition {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 10rem 5rem;
  background-color: #fff;
}

.vision-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 3rem;
  margin-top: 4rem;
  width: 100%;
  max-width: 1400px;
}

.main-title {
  font-size: 3rem;
  margin-bottom: 2rem;
  font-weight: bold;
  text-align: center;
  color: #000;
}

.vision-description {
  font-size: 1.2rem;
  padding: 1rem 2rem;
  color: #7e7e7e;
  width: 75%;
  max-width: 800px;
  margin-bottom: 4rem;
  text-align: center;
}

@media (max-width: 1200px) {
  .vision-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 3rem 2rem;
  }
}

@media (max-width: 768px) {
  .organism-value-proposition {
    padding: 5rem 1rem;
  }

  .main-title {
    font-size: 2rem;
    margin-bottom: 2.5rem;
    font-weight: bold;
  }

  .vision-description {
    width: 100%;
    padding: 0;
  }

  .vision-cards {
    grid-template-columns: 1fr;
    gap: 2.5rem;
    max-width: 500px;
  }
}
</style>
